import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
import english from './locales/en.json';
import {
  DEFAULT_LANGUAGE,
  LANGUAGE_OPTIONS,
  resolveLanguage
} from './languageRegistry';

export const i18n = createInstance();
void i18n.use(initReactI18next).init({
  lng: DEFAULT_LANGUAGE,
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: LANGUAGE_OPTIONS.map(({ value }) => value),
  resources: { en: english },
  ns: Object.keys(english),
  defaultNS: 'common',
  initImmediate: false,
  interpolation: { escapeValue: false },
  returnEmptyString: false,
  react: { useSuspense: false }
});
const pending = new Map<string, Promise<void>>();
export const loadLanguage = async (language: string) => {
  const code = resolveLanguage(language);
  if (i18n.hasResourceBundle(code, 'common')) return;
  if (!pending.has(code)) {
    pending.set(
      code,
      import(`./locales/${code}.json`)
        .then((module) => {
          Object.entries(module.default).forEach(([namespace, translations]) =>
            i18n.addResourceBundle(code, namespace, translations, true, true)
          );
        })
        .catch((error) => {
          pending.delete(code);
          throw error;
        })
    );
  }
  await pending.get(code);
};
